import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { useRoute } from 'vue-router/composables'
import { useAuth } from '@/composables/useAuth'
import { useWebPush } from '@/composables/useWebPush'


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferWebPushCard',
  setup(__props) {

const route = useRoute()
const { isAuthenticated } = useAuth()
const { available, enabled, permission, enable, disable } = useWebPush()

// 「今はしない」を選んだら、次からは案内を開かずボタンに畳んでおく
const dismissed = useLocalStorage('web_push_prompt_dismissed', false)
const expandedByUser = ref<boolean | null>(null)
const busy = ref(false)
const statusText = ref('')

const visible = computed(
  () =>
    available.value && isAuthenticated.value && route.path.startsWith('/mypage')
)
const expanded = computed(
  () =>
    expandedByUser.value ??
    (!enabled.value && !dismissed.value && permission.value === 'default')
)

function collapse() {
  expandedByUser.value = false
  dismissed.value = true
}

async function onToggle(next: boolean) {
  // 操作したら結果の表示が消えないよう開いたままにする
  expandedByUser.value = true
  busy.value = true
  statusText.value = ''
  try {
    if (!next) {
      await disable()
      statusText.value = 'ブラウザ通知をオフにしました'
      return
    }
    const result = await enable()
    statusText.value =
      result === 'enabled'
        ? 'ブラウザ通知をオンにしました'
        : result === 'denied'
          ? ''
          : '通知の設定に失敗しました。時間をおいてもう一度お試しください'
  } finally {
    busy.value = false
  }
}

return { __sfc: true,route, isAuthenticated, available, enabled, permission, enable, disable, dismissed, expandedByUser, busy, statusText, visible, expanded, collapse, onToggle }
}

})